import React, { useState } from 'react'
import { connect } from 'react-redux'
import Password from './Password'
import { authIdSelector } from 'Authorization/modules/selectors'
import { passwordSubmit } from 'Authorization/api/password'
import PropTypes from 'prop-types'

const PasswordContainer = (props) => {
  const [invalidPassword, setInvalidPassword] = useState(false)

  const handlePasswordSubmit = (value) => {
    passwordSubmit(props.authId, value)
      .then(data => {
        setInvalidPassword(false)
        const redirectUrl = data.redirect_to + document.location.hash
        window.location.replace(redirectUrl)
      })
      .catch(e => {
        const responseData = e.response.data
        if (Object.prototype.hasOwnProperty.call(responseData, 'redirect_to')) {
          window.location.replace(responseData.redirect_to)
        } else {
          setInvalidPassword(true)
        }
      })
  }

  return (
    <Password
      locale={props.locale}
      onPasswordSubmit={handlePasswordSubmit}
      invalidPassword={invalidPassword} />
  )
}

const mapStateToProps = (state) => {
  return {
    authId: authIdSelector(state)
  }
}

PasswordContainer.propTypes = {
  authId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired
}

export default connect(mapStateToProps, null)(PasswordContainer)
